export default __webpack_public_path__ + "static/media/826.da7f3cc5.png";